var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CommunicationNetworkGraphTeamPersonChatLinkInspectorContent } from '@web/components/CommunicationNetworkGraph/components/CommunicationNetworkGraphTeamPersonChatLinkInspectorContent';
/** CARD-42 / CARD-43 — selected employee ↔ colleague chat pair metrics. */
export var CommunicationNetworkGraphEmployeeScopePersonChatLinkInspectorContent = function (_a) {
    var focusPersonName = _a.focusPersonName, colleaguePersonName = _a.colleaguePersonName, focusIsSourceEndpoint = _a.focusIsSourceEndpoint, sentMetricRow = _a.sentMetricRow, avgResponsePrimary = _a.avgResponsePrimary, avgResponseSecondary = _a.avgResponseSecondary, sharedGroupsField = _a.sharedGroupsField, showExtended = _a.showExtended;
    return (_jsx(CommunicationNetworkGraphTeamPersonChatLinkInspectorContent, { primaryPersonName: focusPersonName, secondaryPersonName: colleaguePersonName, sentMetricRow: focusIsSourceEndpoint
            ? sentMetricRow
            : __assign(__assign({}, sentMetricRow), { source: sentMetricRow.target, target: sentMetricRow.source, format: sentMetricRow.format
                    ? {
                        source: sentMetricRow.format.target,
                        target: sentMetricRow.format.source
                    }
                    : undefined }), avgResponsePrimary: focusIsSourceEndpoint ? avgResponsePrimary : avgResponseSecondary, avgResponseSecondary: focusIsSourceEndpoint ? avgResponseSecondary : avgResponsePrimary, sharedGroupsField: sharedGroupsField, showExtended: showExtended }));
};
